<div class="sidebar-overlay" (click)="closeSidebar()"></div>

<div class="sidebar d-flex flex-column flex-shrink-0 p-3">
    <div class="sidebar-logo-container">
        <div class="sidebar-logo">
        </div>
    </div>

    <ul class="nav nav-pills flex-column mb-auto mt-4">
        <ng-container *ngFor="let item of menuItems">
            <li class="nav-item" *ngIf="item.parentId != 999">
                <a *ngIf="!item.children?.length" [routerLink]="item.route" class="nav-link"
                    [class.active]="item.isActive" (click)="toggleMenu(item, menuItems)"
                >
                    <i *ngIf="item.icon" class="bi me-2" [ngClass]="item.icon"></i>
                    <span  [translate]="'Menu.' + item.name"> </span>
                </a>

                <div *ngIf="item.children?.length">
                    <a class="nav-link" (click)="toggleMenu(item, menuItems)" [class.active]="item.isOpen">
                        <i *ngIf="item.icon" class="bi me-2" [ngClass]="item.icon"></i>
                        <span  [translate]="'Menu.' + item.name"> </span>
                        <i class="bi" [ngClass]="item.isOpen ? 'bi-chevron-up' : 'bi-chevron-down'"
                            class="float-end"></i>
                    </a>

                    <ul *ngIf="item.isOpen" class="submenu list-unstyled">
                        <ng-container
                            *ngTemplateOutlet="recursiveMenu; context: { $implicit: item.children, level: 1 }"></ng-container>
                    </ul>
                </div>
            </li>
        </ng-container>
    </ul>

    <!-- Recursive Template for Submenus -->
    <ng-template #recursiveMenu let-items let-level="level">
        <ng-container *ngFor="let item of items">
            <li class="nav-item">
                <a *ngIf="!item.children?.length" [routerLink]="item.route" class="nav-link"
                    [class.active]="item.isActive" (click)="toggleMenu(item, items)">
                    <i *ngIf="item.icon" class="bi me-2" [ngClass]="item.icon"></i>
                    <span  [translate]="'Menu.' + item.name"  [ngStyle]="{ 'padding-left.px': level >= 2 ? level * 15 : null }"> </span>
                </a>

                <div *ngIf="item.children?.length">
                    <a class="nav-link" (click)="toggleMenu(item, items)" [class.active]="item.isOpen">
                        <i *ngIf="item.icon" class="bi me-2" [ngClass]="item.icon" ></i>
                        <span  [translate]="'Menu.' + item.name"> </span>

                        <i class="bi" [ngClass]="item.isOpen ? 'bi-chevron-up' : 'bi-chevron-down'"
                            class="float-end"></i>
                    </a>

                    <ul *ngIf="item.isOpen" class="submenu list-unstyled">
                        <ng-container
                            *ngTemplateOutlet="recursiveMenu; context: { $implicit: item.children, level: level + 1 }"></ng-container>
                    </ul>
                </div>
            </li>
        </ng-container>
    </ng-template>

</div>
